import Image from '@components/Image'

export default function WebsiteCoinsImage() {
  return (
    <div className="flex items-center mr-1">
      <Image
        src="https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FM6Wexw4yRsJDacfMJ-website-coins.svg"
        alt="WebsiteCoinsLogo2"
        title="logo"
        height={20}
        width={20}
        objectFit="contain"
      />
    </div>
  )
}
